import addEventListener from 'utils/DOM/addEventListener'
import addStyleToHead from '@hc-frontend/shared-assets/src/js/utils/dom/addStyleToHead'

function loadBreeSerifHandler() {
  import(
    /* webpackChunkName: "fonts/breeSerifFont" */
    '!!raw-loader!scss/breeSerifFont'
  ).then(bundle => addStyleToHead(bundle.default))
}

function loadBreeSerifFontAfterFinishToRender() {
  addEventListener(window, 'DOMContentLoaded', loadBreeSerifHandler)
}

export default loadBreeSerifFontAfterFinishToRender
